export default {
    REFRESH: "Обновить",
    REFRESH_CONFIRM_TEXT: "Вы уверены, что хотите обновить?",
    REFRESH_CONFIRM_DESCRIPTION: "Все несохраненные данные будут утеряны"
};
